import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import Chatbot from "../pages/Chatbot";
import chatbotLogo from "../assets/chatbot-logo.png";

const ChatbotWidget = () => {
  const [isChatbotVisible, setChatbotVisible] = useState(false);

  const toggleChatbot = () => setChatbotVisible((prev) => !prev);

  return (
    <div className="ai-widget-wrapper">
      <motion.div
        initial={{ scale: 0, rotate: -20 }}
        animate={{ 
          scale: (isChatbotVisible && window.innerWidth <= 768) ? 0 : 1, 
          rotate: 0,
          opacity: (isChatbotVisible && window.innerWidth <= 768) ? 0 : 1
        }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={toggleChatbot}
        className={`chatbot-fab-modern ${isChatbotVisible ? "chat-open" : ""} ${isChatbotVisible && window.innerWidth <= 768 ? "mobile-hidden" : ""}`}
      >
        <div className="fab-icon-container">
          <AnimatePresence mode="wait">
            {!isChatbotVisible ? (
              <motion.div
                key="chat-ico"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                className="fab-content"
              >
                <img src={chatbotLogo} alt="AI" className="fab-avatar" />
                <span className="fab-pulse-ring"></span>
              </motion.div>
            ) : (
              <motion.div
                key="close-ico"
                initial={{ opacity: 0, rotate: -90 }}
                animate={{ opacity: 1, rotate: 0 }}
                exit={{ opacity: 0, rotate: 90 }}
                className="close-icon-wrap"
              >
                <FaTimes />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        
        {!isChatbotVisible && (
          <div className="fab-tooltip d-none d-md-block">
            <div className="tooltip-text">IBA Virtual Assistant</div>
            <div className="tooltip-sub">Ask me anything!</div>
          </div>
        )}
      </motion.div>
      
      <AnimatePresence>
        {isChatbotVisible && <Chatbot onClose={toggleChatbot} />}
      </AnimatePresence>

      <style>{`
        .ai-widget-wrapper { 
          position: fixed; 
          bottom: 30px; 
          right: 30px; 
          z-index: 30000;
          display: flex;
          align-items: center;
          gap: 15px;
        }
        
        .chatbot-fab-modern { 
          width: 65px;
          height: 65px;
          background: #fff;
          border-radius: 50% 50% 5px 50%;
          cursor: pointer; 
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 30px rgba(0, 43, 90, 0.25);
          position: relative;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 2px solid white;
        }

        .chatbot-fab-modern.chat-open {
          background: #002b5a;
          border-radius: 50%;
          border-color: #00ced1;
          box-shadow: 0 10px 40px rgba(0, 206, 209, 0.3);
        }

        .fab-icon-container {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .fab-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          object-fit: cover;
        }

        .close-icon-wrap {
          font-size: 1.5rem;
          color: #00ced1;
        }

        /* Pulse Animation */
        .fab-pulse-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border: 3px solid #00ced1;
          border-radius: 50%;
          animation: fab-pulse 2s infinite;
          pointer-events: none;
        }

        @keyframes fab-pulse {
          0% { transform: scale(1); opacity: 0.5; }
          100% { transform: scale(1.6); opacity: 0; }
        }

        /* Tooltip style */
        .fab-tooltip {
          position: absolute;
          right: 80px;
          background: #002b5a;
          padding: 8px 18px;
          border-radius: 12px;
          color: white;
          white-space: nowrap;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
          opacity: 0;
          transform: translateX(10px);
          transition: 0.3s;
          pointer-events: none;
        }

        .chatbot-fab-modern:hover .fab-tooltip {
          opacity: 1;
          transform: translateX(0);
        }

        .tooltip-text { font-weight: 700; font-size: 0.85rem; line-height: 1.2; }
        .tooltip-sub { font-size: 0.7rem; color: #00ced1; font-weight: 500; }

        @media (max-width: 768px) {
          .ai-widget-wrapper { bottom: 20px; right: 20px; }
          .chatbot-fab-modern { width: 55px; height: 55px; }
          .chatbot-fab-modern.mobile-hidden { 
            transform: scale(0) !important; 
            opacity: 0 !important; 
            pointer-events: none !important; 
          }
          .fab-avatar { width: 42px; height: 42px; }
        }
      `}</style>
    </div>
  );
};

export default ChatbotWidget;
